import { IDefaultSuccessResponse, TAxiosResponse } from './baseApiTypes';
import { api } from './index';

export enum NOTIFICATION_TYPES {
  Interview = 'interview',
  Question = 'question',
}

export interface INotification {
  created_at: string;
  data: string;
  id: number;
  notifiable_id: number;
  notifiable_type: string;
  read_at: string | null;
  type: NOTIFICATION_TYPES;
  updated_at: string;
}

export const getNotification = (): TAxiosResponse<any> =>
  api.get('/notifications');

export const getConversationCountUnread = (): TAxiosResponse<
  IDefaultSuccessResponse<{
    count_unread: number;
  }>
> => api.get('/conversation/count-unread');

export const markNotificationAsRead = (id: number): TAxiosResponse<any> =>
  api.post(`/notifications/read/${id}`);

export const OtherApi = {
  getNotification,
  markNotificationAsRead,
  getConversationCountUnread,
};
